import { useContext, useState } from 'react';
import { useMutation } from '@apollo/client/react';

import { CREATE_REPLENISHMENT } from '@atom/graph/assetRequest';
import { ReplenishmentCreateInput } from '@atom/types/assetRequest';

import ViewRequestContext from '../ViewRequestContext';

import AddReplenishmentForm from './AddReplenishmentForm';

interface Props {
  onCancel: () => void;
}

const AddReplenishmentView = ({ onCancel }: Props) => {
  const { activeRequest, handleGetActiveRequest, onAssetRefresh } =
    useContext(ViewRequestContext);

  const [inputs, setInputs] = useState<ReplenishmentCreateInput>();

  const [createReplenishment] = useMutation(CREATE_REPLENISHMENT);

  const updateInput = (
    value: any,
    property: keyof ReplenishmentCreateInput,
  ) => {
    setInputs(prev => ({ ...prev, [property]: value }));
  };

  const handleReset = () => {
    setInputs(null);
    onCancel();
  };

  const onCreate = async () => {
    await createReplenishment({
      variables: {
        input: {
          id: activeRequest.id,
          ...inputs,
        },
      },
    });

    handleGetActiveRequest();
    handleReset();
    onAssetRefresh?.();
  };

  const totalQuantityReceived = activeRequest?.replenishments?.reduce(
    (acc, replenishment) => {
      return acc + Number(replenishment.quantityReceived || 0);
    },
    0,
  );

  return (
    <AddReplenishmentForm
      assetUnit={activeRequest?.assetUnit}
      totalOrdered={activeRequest?.quantityOrdered}
      totalReceived={totalQuantityReceived}
      replenishmentInputs={inputs}
      updateReplenishmentInput={updateInput}
      onCreate={onCreate}
      onCancel={handleReset}
    />
  );
};

export default AddReplenishmentView;
